import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, Typography, // eslint-disable-next-line no-unused-vars
 } from '@mui/material';
import { styled } from '../../../../utils';
const ButtonContainerStyled = styled('div', {
    shouldForwardProp: (prop) => prop !== 'startOfRange' && prop !== 'endOfRange' && prop !== 'highlighted',
})(({ theme, startOfRange, endOfRange, highlighted }) => ({
    display: 'flex',
    ...(startOfRange && {
        borderRadius: '50% 0 0 50%',
    }),
    ...(endOfRange && {
        borderRadius: '0 50% 50% 0',
    }),
    ...(highlighted && {
        backgroundColor: theme.palette.action.hover,
    }),
}));
const IconButtonStyled = styled(IconButton, {
    shouldForwardProp: (prop) => prop !== 'outlined' && prop !== 'filled',
})(({ theme, outlined, filled }) => ({
    height: '36px',
    width: '36px',
    padding: 0,
    ...(outlined && {
        border: `1px solid ${theme.palette.primary.dark}`,
    }),
    ...(filled && {
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
        backgroundColor: theme.palette.primary.dark,
    }),
}));
const TypoStyled = styled(Typography, {
    shouldForwardProp: (prop) => prop !== 'filled',
})(({ theme, filled }) => ({
    lineHeight: 1.6,
    ...(filled && {
        color: theme.palette.primary.contrastText,
    }),
}));
const Day = ({ startOfRange, endOfRange, disabled, highlighted, outlined, filled, onClick, onHover, value, }) => (_jsx(ButtonContainerStyled, { startOfRange: startOfRange, endOfRange: endOfRange, highlighted: highlighted, children: _jsx(IconButtonStyled, { outlined: outlined, filled: filled, onClick: onClick, onMouseOver: onHover, size: "medium", className: disabled ? 'Mui-disabled' : '', children: _jsx(TypoStyled, { color: "inherit", filled: filled, variant: "body2", children: value }) }) }));
export default Day;
